var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.21 4.36001C15.17 2.26001 13.16 0.710011 10.83 0.200011C8.39 -0.339989 5.89 0.240011 3.98 1.78001C2.06 3.31001 0.970001 5.60001 0.970001 8.05001C0.970001 10.64 2.52 13.35 4.86 14.92V15.75C4.85 16.03 4.84 16.46 5.18 16.81C5.53 17.17 6.05 17.21 6.46 17.21H11.59C12.13 17.21 12.54 17.06 12.82 16.78C13.2 16.39 13.19 15.89 13.18 15.62V14.92C16.28 12.83 18.23 8.42001 16.21 4.36001ZM10.72 9.62001L9.65 11.48C9.51 11.72 9.26 11.86 9 11.86C8.87 11.86 8.74 11.83 8.63 11.76C8.27 11.55 8.15 11.09 8.35 10.74L9.2 9.26001H8.36C7.86 9.26001 7.45 9.04001 7.23 8.67001C7.01 8.29001 7.03 7.83001 7.28 7.39001L8.35 5.53001C8.56 5.17001 9.02 5.05001 9.37 5.25001C9.73 5.46001 9.85 5.92001 9.65 6.27001L8.8 7.75001H9.64C10.14 7.75001 10.55 7.97001 10.77 8.34001C10.99 8.72001 10.97 9.19001 10.72 9.62001Z",
    fill: "#5B98D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSecondary);
export default __webpack_public_path__ + "static/media/info-secondary.0f179338.svg";
export { ForwardRef as ReactComponent };